import { createApp } from 'vue';
import App from './App.vue'
import router from './router';
import store from '@/modules/adaptedStorage';
import { IonicVue } from '@ionic/vue';


/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/cyan.scss';

import { defineCustomElements } from '@ionic/pwa-elements/loader';

// Service worker
import './registerServiceWorker'

import VueEasyLightbox from 'vue-easy-lightbox';

defineCustomElements(window);

const errorHandler = function(msg: any, url: any, line: any, col: any, error: any) {
  console.log ("onError", msg, url, line, col, error);
};
window.onerror = errorHandler;

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(store)
  .use(VueEasyLightbox);

app.config.errorHandler = function(err: any, vm: any, info: any) {
  console.log(`Error: ${err.toString()}\nInfo: ${info}`);
};

router.isReady().then(() => {
  app.mount('#app');
});